import React from 'react';

import { StatsRow } from '../helpers';
import TableVisualization from './TableVisualization';

const defaultStatsValue = {
  __typename: '',
  timePeriod: null,
  player: null,
  gameDescriptor: null,
  affiliateId: null,
  allWins: null,
  amountAdjustments: null,
  amountAllBonus: null,
  amountBonusAdjustments: null,
  amountCashbacks: null,
  amountDeposits: null,
  amountFailedDeposits: null,
  amountFailedWithdrawals: null,
  amountFtd: null,
  amountFreeSpinWins: null,
  amountMoneyDrops: null,
  amountReversals: null,
  amountWithdrawableWinnings: null,
  amountWithdrawals: null,
  AvgBetSize: null,
  AvgDepositAmount: null,
  AvgDepositPerUser: null,
  AvgRevenuePerUser: null,
  brand: null,
  calculatedBalance: null,
  campaignId: null,
  cashBackEnableLookup: null,
  currency: null,
  device: null,
  ftd: null,
  ftdOfNrc: null,
  gameId: null,
  gameCategoryLookup: null,
  gameProvider: null,
  gameNameLookup: null,
  ggr: null,
  isIncognito: null,
  isLiveCasinoGameLookup: null,
  jpc: null,
  margin: null,
  moneyDropType: null,
  NetDeposits: null,
  ngr: null,
  ngrInRewards: null,
  nrc: null,
  nrcByNsc: null,
  nsc: null,
  numAdjustments: null,
  numBlockAccountRequests: null,
  numCancelSelfExclusionRequests: null,
  numCashbacks: null,
  numCloseAccountRequests: null,
  numDeposits: null,
  numFailedDeposits: null,
  numFailedWithdrawals: null,
  numReopenAccountRequests: null,
  numReversals: null,
  numSelfExclusionRequests: null,
  numTotalCloseAccountRequests: null,
  numUniqueActivePlayers: null,
  numUniqueDepositors: null,
  numUniqueActiveDepositors: null,
  numUniquePlayers: null,
  numUniqueActiveGlobalPlayers: null,
  numUniqueSessions: null,
  numWithdrawals: null,
  os: null,
  paymentProvider: null,
  pendingWithdrawals: null,
  playerAccountStatusLookup: null,
  playerCurrentSegment: null,
  playerId: null,
  residenceCountryCode: null,
  turnover: null,
  volatilityLookup: null,
  wagers: null,
};

const createStatsValue = (
  entry: Partial<StatsRow> & Pick<StatsRow, '__typename'>,
): StatsRow => ({
  ...defaultStatsValue,
  ...entry,
});

const stats: StatsRow[] = [
  createStatsValue({
    timePeriod: '2021-04-05T00:00:00.000Z',
    currency: 'CAD',
    turnover: 1104.3,
    __typename: 'StatsEntryType',
  }),
  createStatsValue({
    timePeriod: '2021-04-05T00:00:00.000Z',
    currency: 'EUR',
    turnover: 113.01,
    __typename: 'StatsEntryType',
  }),
  createStatsValue({
    timePeriod: '2021-04-12T00:00:00.000Z',
    currency: 'CAD',
    turnover: 290,
    __typename: 'StatsEntryType',
  }),
  createStatsValue({
    timePeriod: '2021-04-12T00:00:00.000Z',
    currency: 'EUR',
    turnover: 28.2,
    __typename: 'StatsEntryType',
  }),
  createStatsValue({
    timePeriod: '2021-04-12T00:00:00.000Z',
    currency: 'NOK',
    turnover: 20,
    __typename: 'StatsEntryType',
  }),
  createStatsValue({
    timePeriod: '2021-04-12T00:00:00.000Z',
    currency: 'NZD',
    turnover: 4,
    __typename: 'StatsEntryType',
  }),
  createStatsValue({
    timePeriod: '2021-04-12T00:00:00.000Z',
    currency: 'ZAR',
    turnover: 80,
    __typename: 'StatsEntryType',
  }),
  createStatsValue({
    timePeriod: '2021-04-19T00:00:00.000Z',
    currency: 'CAD',
    turnover: 162,
    __typename: 'StatsEntryType',
  }),
  createStatsValue({
    timePeriod: '2021-04-19T00:00:00.000Z',
    currency: 'EUR',
    turnover: 27.35,
    __typename: 'StatsEntryType',
  }),
  createStatsValue({
    timePeriod: '2021-04-19T00:00:00.000Z',
    currency: 'NZD',
    turnover: 0,
    __typename: 'StatsEntryType',
  }),
  createStatsValue({
    timePeriod: '2021-04-19T00:00:00.000Z',
    currency: 'ZAR',
    turnover: 105,
    __typename: 'StatsEntryType',
  }),
  createStatsValue({
    timePeriod: '2021-04-26T00:00:00.000Z',
    currency: 'CAD',
    turnover: 1297,
    __typename: 'StatsEntryType',
  }),
  createStatsValue({
    timePeriod: '2021-04-26T00:00:00.000Z',
    currency: 'EUR',
    turnover: 12529.650000000001,
    __typename: 'StatsEntryType',
  }),
  createStatsValue({
    timePeriod: '2021-04-26T00:00:00.000Z',
    currency: 'NOK',
    turnover: 1022.5,
    __typename: 'StatsEntryType',
  }),
];

const example = () => {
  return (
    <TableVisualization
      columns={['currency']}
      rows={['day']}
      values={['turnover']}
      stats={stats}
    />
  );
};

export default example;
